import React from 'react';
import PropTypes from 'prop-types';
import { useLocaleContext } from '../../context/LocaleContext';
import { getDescription } from '../utils/chartDescriptions';

// One-sentence "what is counted" text shown under a chart or table heading.
const ChartDescription = ({ descriptionKey }) => {
  const text = getDescription(useLocaleContext(), descriptionKey);
  if (!text) return null;
  return (
    <p
      data-testid={`description-${descriptionKey}`}
      style={{ margin: '0.25rem 0 1rem', fontSize: '0.875rem', color: '#666666' }}
    >
      {text}
    </p>
  );
};

ChartDescription.propTypes = {
  descriptionKey: PropTypes.string.isRequired
};

export default ChartDescription;
